import { FaMobileScreenButton } from "react-icons/fa6";

export const WaTableEmptyState = () => (
    <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="w-20 h-20 rounded-2xl bg-slate-800/60 border border-slate-700/40 flex items-center justify-center mb-5">
            <FaMobileScreenButton className="text-slate-600 text-3xl" />
        </div>
        <h3 className="text-base font-bold text-slate-400 mb-1">
            Belum Ada Perangkat
        </h3>
        <p className="text-xs text-slate-600 text-center max-w-xs">
            Hubungkan perangkat WhatsApp pertama Anda untuk mulai mengirim
            pesan.
        </p>
    </div>
);